import { render, staticRenderFns } from "./FormInfo.vue?vue&type=template&id=df844548&scoped=true&"
import script from "./FormInfo.vue?vue&type=script&lang=js&"
export * from "./FormInfo.vue?vue&type=script&lang=js&"
import style0 from "./FormInfo.vue?vue&type=style&index=0&id=df844548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df844548",
  null
  
)

export default component.exports